import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=648bd3b6&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=js&"
export * from "./FileEditor.vue?vue&type=script&lang=js&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=648bd3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648bd3b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VFileInput,VIcon,VImg,VOverlay})
